import React from 'react';
import dot from 'dot-object';

import { repeatObjects, verifyConditional } from '../helper';

import Input, { BasicInput } from './input';
import { propHasValue } from '../../../components/DynamicFormNew/helper';

const Group = ({
  name = null,
  config = {},
  data = {},
  allData = {},
  linkingData = {},
  linkingForms = {},
  ajaxOptions = [],
  cols = 4,
}) => {
  const label = () => {
    function getLabel(label) {
      switch (typeof label) {
        case 'string':
          return label;
        case 'object':
          const labelKey = Object.keys(label).find(cond =>
            verifyConditional(cond, data, allData));
          return label[labelKey];
        default:
          return JSON.stringify(label);
      }
    }
    if (config.sectionLabel) {
      return getLabel(config.sectionLabel);
    }
    if (config.outputLabel) {
      return getLabel(config.outputLabel);
    }
    return getLabel(config.label);
  }

  const dataConditions = () => {
    const condition = config.conditions ? Object.keys(config.conditions)[0] : null;
    if (!condition) {
      return null;
    }
    if (verifyConditional(condition, data, allData)) {
      const groupName = config.dataId ? config.dataId : name;
      try {
        Object.keys(config.conditions[condition]).forEach(key => {
          const [form, input] = config.conditions[condition][key].split('.inputs.');
          dot.str(`${groupName}.${key}`, dot.pick(`${form}.${input}`, data), data);
        });
        Object.keys(config.inputs).forEach(key => delete config.inputs[key].showIf);
        return data;
      } catch (e) {

      }
    }
    return null;
  }

  const _allData = data[name] || {};

  const filtered = repeatObjects(config?.inputs || {}, (key) => key).reduce((all, key) => {
    const _item = config.inputs[key];
    if (_item.showIf) {
      const _verified = verifyConditional(_item.showIf, _allData, allData);
      if (_verified) {
        all[key] = _item;
      }
    } else {
      all[key] = _item;
    }

    return all;
  }, {});

  const excludeKeys = ['position', 'label', 'id'];
  const parent = config.dataId ? config.dataId : name;
  const defaultKey = Object.keys(linkingForms[parent] || {})[0];

  const _filter = ({ all, key, config }) => {
    const _item = config[key];
    if (_item.type === 'modal') {
      const linkingD = linkingData ? (linkingData[_item.dataLink.formNamespace] || {}) : {};
      const parentData = data[parent];
      const modalKey =
        parentData?.stakeholderId ||
        parentData?.locationId ||
        parentData?.lirId ||
        parentData?.eventId ||
        parentData?.datastakeId ||
        parentData?.id ||
        parentData?.documentId;
      const modalData = linkingD[modalKey] || {};

      const form = Object.keys(linkingForms[parent][defaultKey])
        .reduce((f, key) => {
          const input = linkingForms[parent][defaultKey][key];
          if (!excludeKeys.includes(key)) {
            if (input.showIf && !propHasValue(input.table)) {
              if (verifyConditional(input.showIf, modalData, modalData)) {
                f[key] = linkingForms[parent][defaultKey][key];
              }
            } else {
              f[key] = linkingForms[parent][defaultKey][key];
            }
          }
          return f;
        }, {});

      return all + Object.keys(form).reduce((all, key) =>
        _filter({ all, key, config: form }), 0)
    }
    return all + 1;
  }

  const _allLength = Object.keys(filtered).reduce((all, key) =>
    _filter({ all, key, config: filtered }), 0)

  const _length = Object.keys(filtered || {}).length;
  const isEven = _allLength % 2 === 0;

  return (
    <div className="group">
      {label() ? (
        <div className="title">
          <h1>{label()}</h1>
        </div>
      ) : null}
      {repeatObjects(filtered, (key, ind) => {
        const dataId = config.inputs[key].dataId || key;
        return <BasicInput
          linkingData={linkingData}
          key={key}
          parent={config.dataId ? config.dataId : name}
          name={dataId}
          config={config.inputs[key]}
          className={
            isEven ? (
              (ind === _length - 1 || ind === _length - 2) ? 'last' : undefined
            ) : ind === _length - 1 ? 'last' : undefined}
          data={dataConditions() ? dataConditions() : data}
          allData={allData}
          linkingForms={linkingForms}
          cols={cols}
          ajaxOptions={ajaxOptions}>
        </BasicInput>
      })}
    </div>
  );
}

export default Group;
